import { cn } from "helpers/classNames";

type Props = {
  signature?: string | null;
  className?: string;
};

export const SignaturePreview = ({ signature, className }: Props) =>
  !signature ? null : (
    <img
      src={signature}
      className={cn("mt-4 h-12 w-auto", className)}
      style={{ maxWidth: 240 }}
      alt="Customer signature"
    />
  );
